<template>
  <v-sheet class="splash-screen" v-if="visible">
    <v-container fluid transition="fade-transition">
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <div >
            <v-card flat class="d-flex flex-column justify-center align-center">
              <v-img :src="require(`../assets/logos/company/lilly-logo-${$vuetify.theme.dark ? 'dark' : 'light'}.png`)"
              height="100" width="auto" contain class="mx-auto"
              ></v-img>
              <div class="d-flex text-center flex-no-wrap justify-space-between align-center">
                <div class="text-center">
                  <span class="app-name text-center urbanist" v-text="title"></span>
      <!-- <v-chip
      class="ml-0 mb-15"
      color="primary"
    >
      Beta
    </v-chip> -->
                </div>
              </div>
              <v-row class="fill-height mt-10" align-content="center" justify="center">
                <v-col class="text-subtitle-1 text-center pa-0" cols="12">
                  Loading...
                </v-col>
                <v-col cols="12">
                  <v-progress-linear color="primary" indeterminate rounded height="6"></v-progress-linear>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </v-col>
      </v-row>

    </v-container>

  </v-sheet>
</template>

<script>
export default {
  name: 'SplashScreen',
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      title: 'AppBridge',
      subtitle: 'Enterprise Automation'
    }
  }
}
</script>

<style scoped>
.splash-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.app-name {
  font-size: 70px;
}

.app-subtitle {
  margin-top: -20px;
}
</style>
